<template>
  <div class="user_all">
    <!-- <div class="user_search"> 
            <span style="width: 100px;display: inline-block">RPC服务：</span>
            <el-select
                    style="width: 250px"
                    v-model="selectRpc"
                    @change="changeRpc()"
                    placeholder="RPC服务"
            >
                <el-option
                        v-for="item in optionRpc"
                        :key="item.rpcUrl"
                        :label="item.rpcUrl"
                        :value="item.rpcUrl"
                ></el-option>
            </el-select>
            <span style="width: 100px;display: inline-block"></span>
            <el-select
                    style="width: 250px"
                    v-model="selectChain"
                    @change="changeChain()"
                    :placeholder="$t('title.Please_select_the_chain')"
            >
                <el-option
                        v-for="item in optionsChain"
                        :key="item"
                        :label="`${item}链`"
                        :value="item"
                ></el-option>
            </el-select>
                      <el-button type="primary" style="margin-left: 5%" @click="searchRpc()" :loading=isResponse>查询</el-button>
    </div>-->
    <el-button type="primary" @click="createKey">{{ $t('title.Generate_public_and_private_keys') }}</el-button>
    <div id="app" style="margin-top: 30px">
      <div class="layout">
        <div class="setting">
          <ul>
            <li>
              <label>{{ $t('title.theme') }}</label>
              <select v-model="theme">
                <option value>{{ this.$t('title.default') }}</option>
                <option value="one-dark">one-dark</option>
                <option value="vs-code">vs-code</option>
              </select>
            </li>
            <li>
              <label>{{ $t('title.Collapse_all') }}</label>
              <select v-model="closed">
                <option :value="false">false</option>
                <option :value="true">true</option>
              </select>
            </li>

            <li>
              <label>deep</label>
              <select v-model="deep">
                <option v-for="item in 10" :value="item">{{item}}</option>
              </select>
            </li>

            <li>
              <label>font-size</label>
              <select v-model="fontSize">
                <option v-for="item in 10" :value="item+11">{{item+11}}</option>
              </select>
            </li>
            <li>
              <label for="line-height">line-height</label>
              <select v-model="lineHeight">
                <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
              </select>
            </li>
          </ul>
        </div>
        <div class="content">
          <json-view
            :data="json"
            :theme="theme"
            :deep="deep"
            :iconStyle="iconStyle"
            :fontSize="fontSize"
            :lineHeight="lineHeight"
            :closed="closed"
            :iconColor="iconColor"
          />
        </div>
      </div>
    </div>
    <div class="user_search" style="margin-top: 30px">
      <div>{{ $t('title.Return_public_key_and_address_via_private_key') }}</div>
      <div>
        <el-input
          type="primary"
          style="width: 40%;margin-top: 20px"
          :placeholder="this.$t('title.Please_enter_the_private_key')"
          v-model="inputValue"
        ></el-input>
        <el-button type="primary" style="margin-left: 30px" @click="getAddress">{{ this.$t('title.Obtain') }}</el-button>
      </div>
    </div>
    <div id="app" style="margin-top: 30px">
      <div class="layout">
        <div class="setting">
          <ul>
            <li>
              <label>{{ $t('title.theme') }}</label>
              <select v-model="theme">
                <option value>{{ this.$t('title.default') }}</option>
                <option value="one-dark">one-dark</option>
                <option value="vs-code">vs-code</option>
              </select>
            </li>
            <li>
              <label>{{ $t('title.Collapse_all') }}</label>
              <select v-model="closed">
                <option :value="false">false</option>
                <option :value="true">true</option>
              </select>
            </li>

            <li>
              <label>deep</label>
              <select v-model="deep">
                <option v-for="item in 10" :value="item">{{item}}</option>
              </select>
            </li>

            <li>
              <label>font-size</label>
              <select v-model="fontSize">
                <option v-for="item in 10" :value="item+11">{{item+11}}</option>
              </select>
            </li>
            <li>
              <label for="line-height">line-height</label>
              <select v-model="lineHeight">
                <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
              </select>
            </li>
          </ul>
        </div>
        <div class="content">
          <json-view
            :data="json_1"
            :theme="theme_1"
            :deep="deep_1"
            :iconStyle="iconStyle_1"
            :fontSize="fontSize_1"
            :lineHeight="lineHeight_1"
            :closed="closed_1"
            :iconColor="iconColor_1"
          />
        </div>

        <div class="encryption">
            <el-radio v-model="businessId" label="1">{{ $t('title.encryption') }}</el-radio>
            <el-radio v-model="businessId" label="2">{{ $t('title.Decrypt') }}</el-radio>
             <el-input
          type="primary"
          style="width: 40%;margin-top: 20px"
          :placeholder="this.$t('title.please_enter')"
          v-model="encryptedValue"
        ></el-input>
        <el-button type="primary" style="margin-left: 30px" @click="encryptionOrDecrypt">{{ $t('title.Sure') }}</el-button>
        <p>{{encryptedData}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jsonView from "../../json-view/index.vue";
import {
  getchaininfo,
  getrpcserver,
  getkey,
  encryptAddress,
} from "../../../api/interface";
import {
  encryptOrdecrypt
} from "../../../api/sdkApi";

export default {
  name: "PublicPrivateKey",
  components: { jsonView },
  data() {
    return {
      json: {},
      theme: "",
      fontSize: 14,
      lineHeight: 24,
      deep: 3,
      iconStyle: "square",
      closed: false,
      color1: "",
      color2: "",
      json_1: {},
      theme_1: "",
      fontSize_1: 14,
      lineHeight_1: 24,
      deep_1: 3,
      iconStyle_1: "square",
      closed_1: false,
      color1_1: "",
      color2_1: "",

      isResponse: false,
      selectRpc: "",
      seleArr: [],
      optionRpc: [],
      selectChain: "",
      optionsChain: [],
      inputValue: "",
      businessId: '1',
      encryptedValue: '',
      encryptedData: '',
    };
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    },
    iconColor_1() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    }
  },
  methods: {
    changeRpc() {
      let data = { rpcServer: this.selectRpc };
      getchaininfo(data).then(response => {
        this.optionsChain = response.data;
        this.selectChain = this.optionsChain[0];
      });
    },
    changeChain() {},
    getData() {
      getrpcserver().then(response => {
        this.optionRpc = response.data;
        this.selectRpc = this.optionRpc[0].rpcUrl;
        let data = { rpcServer: this.optionRpc[0].rpcUrl };
        getchaininfo(data).then(response => {
          this.optionsChain = response.data;
          this.selectChain = this.optionsChain[0];
        });
      });
    },
    createKey() {
      getkey().then(response => {
        if (response.code == 200) {
          this.json = response.data;
        } else {
          this.json = {};
          this.$message.error(response.msg);
        }
      });
    },
    getAddress() {
      let data = {
        key: this.inputValue
      };
      encryptAddress(data).then(response => {
        if (response.code == 200) {
          this.json_1 = response.data;
        } else {
          this.json_1 = {};
          this.$message.error(response.msg);
        }
      });
    },
    encryptionOrDecrypt() {
      let methods, params
      if(this.businessId == 1) {
        methods = 'encrypt'
        params =  {
          businessId: this.businessId,
          value: this.encryptedValue
        }
      } else {
        methods = 'decrypt'
         params =  {
          businessId: this.businessId,
          encryptedValue: this.encryptedValue
        }
      }

      encryptOrdecrypt(methods, params)
        .then(res => {
          this.encryptedData = res.data
        })
        .catch(() => {
          this.encryptedData = ''
        })
      
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style scoped>
.user_all {
  padding: 20px 30px;
}

.user_search {
  margin-bottom: 30px;
}
</style>
<style scoped lang="less">
#app {
  .layout {
    /*width: 1200px;*/
    /*margin: 0 auto;*/

    h1 {
      font-size: 26px;
      font-weight: 400;
      margin: 12px 0;
    }

    a {
      display: block;
      background-color: #f8f8f9;
      border-radius: 4px;
      padding: 8px 16px;
      border: 1px solid #edeff0;
      border-radius: 4px;
      margin-bottom: 20px;
      text-decoration: none;
      color: #2d8cf0;
    }

    .setting {
      border: 1px solid #ccc;
      padding: 10px 20px;

      h3 {
        line-height: 1.6;
        font-size: 18px;
        color: #333;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;

      li {
        display: flex;
        align-items: center;
        padding: 10px 0;
        padding-right: 20px;

        label {
          font-size: 13px;
          padding-right: 10px;
          color: #333;
        }

        select {
          display: block;
          width: 80px;
          height: 28px;
          background: #fff;
        }
      }
    }

    .content {
      border: 1px solid #ccc;
      border-top: none;
    }
  }
  .encryption {
    margin-top: 20px;
    p {
      margin-top: 10px;
    }
  }
}
</style>
